import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';

export type GetOrgResponse = {
  _id: {
    id: string;
  };
  name: string;
  owner: {
    id: string;
  };
  roles: unknown[];
  members: Array<Record<string, boolean>>;
  memberRoles: Array<{
    id: string;
    roles: Array<{
      id: string;
    }>;
  }>;
  groups: unknown[];
  logo: string;
  dateCreated: string;
  imported: boolean;
  showSearch: boolean;
  brandCreatedOn: string;
  churchAccountId?: string;
};

export const getOrg = (orgId: string): Promise<GetOrgResponse> => {
  return cacheableRequest(`/v1/organizations/${orgId}`).then(({ data }: AxiosResponse<GetOrgResponse>) => data);
};
